import { render, staticRenderFns } from "./RateView.vue?vue&type=template&id=b9ff57ce&scoped=true&"
import script from "./RateView.vue?vue&type=script&lang=js&"
export * from "./RateView.vue?vue&type=script&lang=js&"
import style0 from "./RateView.vue?vue&type=style&index=0&id=b9ff57ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ff57ce",
  null
  
)

export default component.exports